import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import Race20Result from "../../client/tp-studio/tp-result/Race20Result.jsx";
import Volume from "./Volume";
import { isMobile } from "react-device-detect";
import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import RacetwRules from "./pop-up/race20-rules.jsx";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function Race20() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);

  const [SpadesOdds, setSpadesOddsValue] = useState("");
  const [HeartsOdds, setHeartsOddsValue] = useState("");
  const [ClubsOdds, setClubsOddsValue] = useState("");
  const [DiamondsOdds, setDiamondsOddsValue] = useState("");

  const [SpadesPL, setSpadesPL] = useState(0);
  const [HeartsPL, setHeartsPL] = useState(0);
  const [ClubsPL, setClubsPL] = useState(0);
  const [DiamondsPL, setDiamondsPL] = useState(0);

  const [SpadesOddsLay, setSpadesOddsLayValue] = useState("");
  const [HeartsOddsLay, setHeartsOddsLayValue] = useState("");
  const [ClubsOddsLay, setClubsOddsLayValue] = useState("");
  const [DiamondsOddsLay, setDiamondsOddsLayValue] = useState("");

  const [spadesSuspend, setSpadesSuspend] = useState("1");
  const [heartSuspend, setHeartSuspend] = useState("1");
  const [clubsSuspend, setClubsSuspend] = useState("1");
  const [diamondsSuspend, setDiamondsSuspend] = useState("1");

  const [spadesWinner, setSpadesWinner] = useState(false);
  const [heartsWinner, setHeartsWinner] = useState(false);
  const [clubsWinner, setClubsWinner] = useState(false);
  const [diamondsWinner, setDiamondsWinner] = useState(false);

  const [spadesCards, setSpadesCards] = useState([]);
  const [heartsCards, setHeartsCards] = useState([]);
  const [clubsCards, setClubsCards] = useState([]);
  const [diamondsCards, setDiamondsCards] = useState([]);

  const [roundId, setRoundId] = useState(0);
  const [cardDesc, setCardDesc] = useState("");
  const [resultDesc, setResultDesc] = useState("");
  const [result, setResult] = useState("");
  const [resultList, setResultList] = useState([]);
  const [lastStatus, setLastStatus] = useState(null);

  const [resultData, setResultData] = useState([]);
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SINGLE CARD STATE ================= */
  const [shownCard, setShownCard] = useState("1");
  const [shouldFlip, setShouldFlip] = useState(false);
  const lastEvtStatusRef = useRef(null);
  const flipTimerRef = useRef(null);
  const cardsSettleTimerRef = useRef(null);
  const [shownSpadesCards, setShownSpadesCards] = useState([]);
  const [shownHeartsCards, setShownHeartsCards] = useState([]);
  const [shownClubsCards, setShownClubsCards] = useState([]);
  const [shownDiamondsCards, setShownDiamondsCards] = useState([]);
  const [cardsSettled, setCardsSettled] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };
  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "race20"
  });

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  //console.log("data:", payload); // DO NOT REMOVE

  const payloadResult = data?.data?.result;
  //console.log("payloadResult:", payloadResult); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */
  useEffect(() => {
    if (!payload) return;
    setDisplayLoader(false);
    updateUserData(data?.user);
    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setSpadesPL(0);
      setHeartsPL(0);
      setClubsPL(0);
      setDiamondsPL(0);
      setSpadesCards([]);
      setHeartsCards([]);
      setClubsCards([]);
      setDiamondsCards([]);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setRoundId(payload?.cat_mid);
    setSpadesOddsValue(payload?.b1);
    setHeartsOddsValue(payload?.b2);
    setClubsOddsValue(payload?.b3);
    setDiamondsOddsValue(payload?.b4);

    setSpadesOddsLayValue(payload?.l1);
    setHeartsOddsLayValue(payload?.l2);
    setClubsOddsLayValue(payload?.l3);
    setDiamondsOddsLayValue(payload?.l4);

    setSpadesSuspend(payload?.suspend1);
    setHeartSuspend(payload?.suspend2);
    setClubsSuspend(payload?.suspend3);
    setDiamondsSuspend(payload?.suspend4);

    setCardDesc(payload?.cards_desc);
    setResultDesc(payload?.result_desc);

    if (payload?.clubs_cards !== "") {
      let club = payload?.clubs_cards.split(",");
      setClubsCards(club);
    } else {
      setClubsCards([]);
    }

    if (payload?.diamonds_cards !== "") {
      let diamond = payload?.diamonds_cards.split(",");
      setDiamondsCards(diamond);
    } else {
      setDiamondsCards([]);
    }

    if (payload?.hearts_cards !== "") {
      let heart = payload?.hearts_cards.split(",");
      setHeartsCards(heart);
    } else {
      setHeartsCards([]);
    }

    if (payload?.spades_cards !== "") {
      let spades = payload?.spades_cards.split(",");
      setSpadesCards(spades);
    } else {
      setSpadesCards([]);
    }

    setResult(payload?.result);

    if (payload?.result != "") {
      let res = payload?.result;
      if (res === 1) {
        setSpadesWinner(true);
        setHeartsWinner(false);
        setClubsWinner(false);
        setDiamondsWinner(false);
      } else if (res === 2) {
        setSpadesWinner(false);
        setHeartsWinner(true);
        setClubsWinner(false);
        setDiamondsWinner(false);
      } else if (res === 3) {
        setSpadesWinner(false);
        setHeartsWinner(false);
        setClubsWinner(true);
        setDiamondsWinner(false);
      } else if (res === 4) {
        setSpadesWinner(false);
        setHeartsWinner(false);
        setClubsWinner(false);
        setDiamondsWinner(true);
      }

      /*let resultDesc = payload?.result_desc.split(",");
      if (resultDesc.length > 0) {

        for (let i = 0; i < resultDesc.length; i++) {
          if (i == 0) {
            if (resultDesc[0] !== "0") {
              setCard1Winner(true);
            } else {
              setCard1Winner(false);
            }
          }

          if (i == 1) {
            if (resultDesc[1] !== "0") {
              setCard2Winner(true);
            } else {
              setCard2Winner(false);
            }
          }

          if (i == 2) {
            if (resultDesc[2] !== "0") {
              setCard3Winner(true);
            } else {
              setCard3Winner(false);
            }
          }

          if (i == 3) {
            if (resultDesc[3] !== "0") {
              setCard4Winner(true);
            } else {
              setCard4Winner(false);
            }
          }

          if (i == 4) {
            if (resultDesc[4] !== "0") {
              setCard5Winner(true);
            } else {
              setCard5Winner(false);
            }
          }

          if (i == 5) {
            if (resultDesc[5] !== "0") {
              setCard6Winner(true);
            } else {
              setCard6Winner(false);
            }
          }
        }


        
      }*/
    } else {
      setSpadesWinner(false);
      setHeartsWinner(false);
      setClubsWinner(false);
      setDiamondsWinner(false);
    }

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);
  useEffect(
    () => () => {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    },
    []
  );

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;
    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;
    clearTimeout(flipTimerRef.current);

    if (payload.evt_status === "OPEN") {
      setShownSpadesCards([]);
      setShownHeartsCards([]);
      setShownClubsCards([]);
      setShownDiamondsCards([]);
      setShouldFlip(false);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    if (payload.evt_status === "CLOSED") {
      setShouldFlip(true);

      const spades =
        payload?.spades_cards && payload.spades_cards !== ""
          ? payload.spades_cards.split(",")
          : [];
      const hearts =
        payload?.hearts_cards && payload.hearts_cards !== ""
          ? payload.hearts_cards.split(",")
          : [];
      const clubs =
        payload?.clubs_cards && payload.clubs_cards !== ""
          ? payload.clubs_cards.split(",")
          : [];
      const diamonds =
        payload?.diamonds_cards && payload.diamonds_cards !== ""
          ? payload.diamonds_cards.split(",")
          : [];

      // Interleaved sequence: spades → diamonds → hearts → clubs, repeating per round
      const sequence = [];
      const maxLen = Math.max(
        spades.length,
        hearts.length,
        clubs.length,
        diamonds.length
      );
      for (let i = 0; i < maxLen; i++) {
        if (i < spades.length) sequence.push({ suit: "spades", idx: i });
        if (i < diamonds.length) sequence.push({ suit: "diamonds", idx: i });
        if (i < hearts.length) sequence.push({ suit: "hearts", idx: i });
        if (i < clubs.length) sequence.push({ suit: "clubs", idx: i });
      }

      setShownSpadesCards([]);
      setShownHeartsCards([]);
      setShownClubsCards([]);
      setShownDiamondsCards([]);

      if (sequence.length === 0) return;

      let pos = 0;
      let cancelled = false;

      function revealNext() {
        if (cancelled) return;
        const item = sequence[pos];
        if (item.suit === "spades")
          setShownSpadesCards(spades.slice(0, item.idx + 1));
        else if (item.suit === "diamonds")
          setShownDiamondsCards(diamonds.slice(0, item.idx + 1));
        else if (item.suit === "hearts")
          setShownHeartsCards(hearts.slice(0, item.idx + 1));
        else if (item.suit === "clubs")
          setShownClubsCards(clubs.slice(0, item.idx + 1));

        pos++;
        if (pos < sequence.length) {
          flipTimerRef.current = setTimeout(revealNext, 1000);
        }
      }

      flipTimerRef.current = setTimeout(revealNext, 300);

      return () => {
        cancelled = true;
        clearTimeout(flipTimerRef.current);
      };
    }
  }, [payload?.evt_status]);

  useEffect(() => {
    const totalCards =
      spadesCards.length +
      heartsCards.length +
      clubsCards.length +
      diamondsCards.length;

    const allRevealed =
      totalCards > 0 &&
      shownSpadesCards.length >= spadesCards.length &&
      shownHeartsCards.length >= heartsCards.length &&
      shownClubsCards.length >= clubsCards.length &&
      shownDiamondsCards.length >= diamondsCards.length;

    if (!allRevealed) {
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    clearTimeout(cardsSettleTimerRef.current);
    cardsSettleTimerRef.current = setTimeout(() => {
      setCardsSettled(true);
    }, 1000);

    return () => clearTimeout(cardsSettleTimerRef.current);
  }, [
    spadesCards,
    heartsCards,
    clubsCards,
    diamondsCards,
    shownSpadesCards,
    shownHeartsCards,
    shownClubsCards,
    shownDiamondsCards
  ]);

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };
  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_type: 7,
      game_name: "race20_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };


  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "race20_virtual"
    });

    setPlacedBets(res.data);
  }

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "race20_virtual"
    });

    setSpadesPL(res.data?.Spades);
    setHeartsPL(res.data?.Hearts);
    setClubsPL(res.data?.Clubs);
    setDiamondsPL(res.data?.Diamonds);

    //setPlacedBets(res.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          getPlacedBets();
          getBook();
          setShowBetSlipPopup(false);
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getResultDisplayName = (value) => {
    let returnTxt = "";
    if (value === 1) {
      returnTxt = "SP";
    } else if (value === 2) {
      returnTxt = "HE";
    } else if (value === 3) {
      returnTxt = "CL";
    } else {
      returnTxt = "DI";
    }
    return returnTxt;
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "race20_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="race20-virtual-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div className="cards-layout blackjack">
                          <div>
                            <div className="cards-layout blackjack">
                              <div
                                className="col-12 timerDiv2"
                                style={{ paddingLeft: "0px" }}
                              >
                                <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                                  <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                                    <p>RACE-20-20</p>
                                  </div>
                                  <div
                                    className="col-6 col-md-6 inline-block Gameidcol text-center"
                                    style={{ marginTop: "4px" }}
                                  >
                                    <div
                                      role="group"
                                      aria-label="Second group"
                                      class="btn-group btn-group-sm mr-2"
                                      style={{ float: "right" }}
                                    >
                                      <button
                                        style={{
                                          fontSize: "14px",
                                          display: "inline-block"
                                        }}
                                        type="button"
                                        className={
                                          activeTabIndex == 1
                                            ? "tablink btn btn-primary bbactive"
                                            : "tablink btn btn-primary"
                                        }
                                        onClick={() => activeTab(1)}
                                      >
                                        Game
                                      </button>
                                      <button
                                        style={{
                                          fontSize: "14px",
                                          display: "inline-block"
                                        }}
                                        type="button"
                                        className={
                                          activeTabIndex == 2
                                            ? "tablink btn btn-primary bbactive"
                                            : "tablink btn btn-primary"
                                        }
                                        onClick={() => activeTab(2)}
                                      >
                                        Results
                                      </button>
                                      <button
                                        style={{
                                          fontSize: "14px",
                                          display: "inline-block"
                                        }}
                                        type="button"
                                        class="tablink btn btn-primary2 "
                                        data-toggle="modal"
                                        data-target="#rulesPopup"
                                        onClick={() => setShowRules(true)}
                                      >
                                        Rules
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <RacetwRules
                                show={showRules}
                                onClose={() => setShowRules(false)}
                              />

                              <span
                                style={{
                                  opacity: 1,
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              >
                                <span
                                  id="AlltabData"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div
                                    id="videos"
                                    class="collapse show race20-gradient"
                                    aria-labelledby="headingThree"
                                    data-parent="#video"
                                    style={{
                                      textAlign: "center",
                                      padding: "0px",
                                      border: "solid 1px #130a21",
                                      minHeight: "185px",
                                      position: "relative"
                                    }}
                                  >
                                    <div className="race20-timer-row">
                                      <div className="race20-left-col">
                                        <div className="Connectedclients mt-1">
                                          <i
                                            aria-hidden="true"
                                            className="fa fa-user mr-1"
                                            style={{
                                              fontSize: "14px",
                                              color: "white"
                                            }}
                                          />
                                          <b>
                                            <span
                                              id="UsersCount"
                                              className="number"
                                            >
                                              326
                                            </span>
                                          </b>
                                        </div>
                                        <Volume id="Race20Soundcontrol" />
                                      </div>
                                      <div className="teenpatti-base-timer">
                                        <svg
                                          viewBox="0 0 100 100"
                                          className="base-timer__svg"
                                        >
                                          <g className="base-timer__circle">
                                            <circle
                                              cx="50"
                                              cy="50"
                                              r="45"
                                              className="base-timer__path-elapsed"
                                            />
                                            <path
                                              strokeDasharray={`${Math.round(
                                                dash
                                              )} ${Math.round(CIRC)}`}
                                              className={`base-timer__path-remaining ${timerColor}`}
                                              d="
                                                M 50, 50
                                                m -45, 0
                                                a 45,45 0 1,0 90,0
                                                a 45,45 0 1,0 -90,0
                                              "
                                            />
                                          </g>
                                        </svg>
                                        <span className="base-timer__label">
                                          {timeLeft == 1 ? 0 : timeLeft}
                                        </span>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="row">
                                          <div class="player">
                                            <div class="player-item">
                                              <span class="name">
                                                King of Spades
                                              </span>
                                              <div
                                                class="player-card  stood"
                                                style={{
                                                  border:
                                                    "1px solid rgba(178, 220, 175, 0.25)",
                                                  marginLeft: "15px",
                                                  marginRight: "15px"
                                                }}
                                              >
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards1"
                                                    class="BFBCardFanView"
                                                  >
                                                    {" "}
                                                    {shownSpadesCards.map(
                                                      (key, i) => (
                                                        <div
                                                          class="card1"
                                                          key={i}
                                                        >
                                                          <img
                                                            src={`../assets/galaxy/img/cards3/${key}.svg`}
                                                            class="RSMImageView animate__animated animate__flipInY"
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row space">
                                          <div class="player">
                                            <div class="player-item">
                                              <span class="name">
                                                King of Hearts
                                              </span>
                                              <div
                                                class="player-card  stood"
                                                style={{
                                                  border:
                                                    "1px solid rgba(178, 220, 175, 0.25)",
                                                  marginLeft: "15px",
                                                  marginRight: "15px"
                                                }}
                                              >
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards2"
                                                    class="BFBCardFanView"
                                                  >
                                                    {shownHeartsCards.map(
                                                      (key, i) => (
                                                        <div
                                                          class="card1"
                                                          key={i}
                                                        >
                                                          <img
                                                            src={`../assets/galaxy/img/cards3/${key}.svg`}
                                                            class="RSMImageView animate__animated animate__flipInY"
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row space">
                                          <div class="player">
                                            <div class="player-item">
                                              <span class="name">
                                                King of Clubs
                                              </span>
                                              <div
                                                class="player-card  stood"
                                                style={{
                                                  border:
                                                    "1px solid rgba(178, 220, 175, 0.25)",
                                                  marginLeft: "15px",
                                                  marginRight: "15px"
                                                }}
                                              >
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="BFBCardHandView"
                                                >
                                                  <div
                                                    id="game-cards3"
                                                    class="BFBCardFanView"
                                                  >
                                                    {shownClubsCards.map(
                                                      (key, i) => (
                                                        <div
                                                          class="card1"
                                                          key={i}
                                                        >
                                                          <img
                                                            src={`../assets/galaxy/img/cards3/${key}.svg`}
                                                            class="RSMImageView animate__animated animate__flipInY"
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row space">
                                          <div class="player">
                                            <div class="player-item">
                                              <span class="name">
                                                King of Diamonds
                                              </span>
                                              <div
                                                class="player-card  stood"
                                                style={{
                                                  border:
                                                    "1px solid rgba(178, 220, 175, 0.25)",
                                                  marginLeft: "15px",
                                                  marginRight: "15px"
                                                }}
                                              >
                                                <div class="header-title">
                                                  <span class="status"></span>
                                                </div>
                                                <div
                                                  id="BFBCardHandView"
                                                  class="BFBCardHandView"
                                                >
                                                  <div class="BFBCardFanView">
                                                    {shownDiamondsCards.map(
                                                      (key, i) => (
                                                        <div
                                                          class="card1"
                                                          key={i}
                                                        >
                                                          <img
                                                            src={`../assets/galaxy/img/cards3/${key}.svg`}
                                                            class="RSMImageView animate__animated animate__flipInY"
                                                          />
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row resultDiv">
                                    <div class="results-div" id="lastresults">
                                      {Object.keys(resultList).map((key) => (
                                        <button class="video-button mob-hide">
                                          {getResultDisplayName(
                                            resultList[key]
                                          )}
                                        </button>
                                      ))}
                                      {Object.keys(resultList).map((key) => (
                                        <button class="video-button ">
                                          {" "}
                                          {getResultDisplayName(
                                            resultList[key]
                                          )}
                                        </button>
                                      ))}
                                    </div>
                                    <div class="round-div">
                                      <div class="label">Round ID:</div>{" "}
                                      <div id="round-id">{roundId}</div>
                                    </div>
                                  </div>

                                  <div
                                    class="tb-content"
                                    style={{ background: "#fff" }}
                                  >
                                    <div class="market-titlebar">
                                      <p class="market-name">
                                        <span class="market-name-badge">
                                          <i class="market-name-icon">
                                            <img
                                              src="/assets/images/time-img.png"
                                              style={{
                                                filter: "invert(100%)",
                                                marginTop: "-8px",
                                                marginLeft: "-1px"
                                              }}
                                            />
                                          </i>
                                          <span>MATCH ODDS </span>
                                        </span>
                                      </p>
                                      <div class="market-overarround">
                                        <span></span>
                                        <strong>Back</strong>
                                      </div>
                                      <div class="market-overarround market-overarround-lay">
                                        <strong>Lay</strong>
                                      </div>
                                    </div>
                                    <div class="market-runners">
                                      <div
                                        class={
                                          spadesWinner && cardsSettled
                                            ? "runner-runner sussesBg"
                                            : "runner-runner"
                                        }
                                      >
                                        <h3 class="runner-name" id="b1Sucess">
                                          <div class="runner-info">
                                            <span class="clippable runner-display-name">
                                              <table>
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      <h4
                                                        style={{
                                                          marginBottom: "0px",
                                                          fontSize: "16px",
                                                          fontWeight: "700"
                                                        }}
                                                        class="clippable-spacer"
                                                      >
                                                        King of Spades
                                                      </h4>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>
                                                      <div
                                                        style={{
                                                          float: "left",

                                                          color:
                                                            SpadesPL > 0
                                                              ? "green"
                                                              : "red"
                                                        }}
                                                      >
                                                        {SpadesPL != 0
                                                          ? formatTruncate(
                                                              SpadesPL
                                                            )
                                                          : " "}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </span>
                                          </div>
                                        </h3>

                                        <div class="price-row-box-new">
                                          <div
                                            class={
                                              isSuspended
                                                ? "runner-disabled2 suspendCls"
                                                : "runner-disabled2 suspendCls hides"
                                            }
                                          >
                                            {suspendedText}
                                          </div>
                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a
                                            class="price-price price-back mb-show span1details"
                                            id="runner1b1span"
                                            data-teamname="Spades"
                                            data-bettype="b"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "b",
                                                "Spades",
                                                "Spades",
                                                SpadesOdds,
                                                "m",
                                                1
                                              )
                                            }
                                          >
                                            <div id="rnr1" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner1b1"
                                              >
                                                {SpadesOdds}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate1"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a
                                            class="price-price price-lay ml-4 mb-show span1details"
                                            id="runner1l1span"
                                            data-teamname="Spades"
                                            data-bettype="l"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "l",
                                                "Spades",
                                                "Spades",
                                                SpadesOddsLay,
                                                "m",
                                                1
                                              )
                                            }
                                          >
                                            <div id="rnr11" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner1l1"
                                              >
                                                {SpadesOddsLay}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate11"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a class="price-price price-lay whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-lay mr-4 whtBack">
                                            <div>&nbsp;</div>
                                          </a>
                                        </div>
                                      </div>

                                      <div
                                        class={
                                          heartsWinner && cardsSettled
                                            ? "runner-runner sussesBg"
                                            : "runner-runner"
                                        }
                                      >
                                        <h3 class="runner-name" id="b2Sucess">
                                          <div class="runner-info">
                                            <span class="clippable runner-display-name">
                                              <table>
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      <h4
                                                        style={{
                                                          marginCottom: "0px",
                                                          fontSize: "16px",
                                                          fontWeight: "700"
                                                        }}
                                                        class="clippable-spacer"
                                                      >
                                                        King of Hearts
                                                      </h4>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>
                                                      <div
                                                        id="bstatus2"
                                                        style={{
                                                          float: "left",
                                                          color:
                                                            HeartsPL > 0
                                                              ? "green"
                                                              : "red"
                                                        }}
                                                      >
                                                        {HeartsPL != 0
                                                          ? formatTruncate(
                                                              HeartsPL
                                                            )
                                                          : " "}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </span>
                                          </div>
                                        </h3>

                                        <div class="price-row-box-new">
                                          <div
                                            class={
                                              isSuspended
                                                ? "runner-disabled2 suspendCls"
                                                : "runner-disabled2 suspendCls hides"
                                            }
                                          >
                                            {suspendedText}
                                          </div>

                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a
                                            class="price-price price-back mb-show span1details"
                                            data-teamname="Hearts"
                                            data-bettype="b"
                                            id="runner2b1span"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "b",
                                                "Hearts",
                                                "Hearts",
                                                HeartsOdds,
                                                "m",
                                                2
                                              )
                                            }
                                          >
                                            <div id="rnr2" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner2b1"
                                              >
                                                {HeartsOdds}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate2"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a
                                            class="price-price price-lay ml-4 mb-show span1details"
                                            data-teamname="Hearts"
                                            data-bettype="l"
                                            id="runner2l1span"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "l",
                                                "Hearts",
                                                "Hearts",
                                                HeartsOddsLay,
                                                "m",
                                                2
                                              )
                                            }
                                          >
                                            <div id="rnr22" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner2l1"
                                              >
                                                {HeartsOddsLay}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate22"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a class="price-price price-lay whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-lay mr-4 whtBack">
                                            <div>&nbsp;</div>
                                          </a>
                                        </div>
                                      </div>

                                      <div
                                        class={
                                          clubsWinner && cardsSettled
                                            ? "runner-runner sussesBg"
                                            : "runner-runner"
                                        }
                                      >
                                        <h3 class="runner-name" id="b3Sucess">
                                          <div class="runner-info">
                                            <span class="clippable runner-display-name">
                                              <table>
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      <h4
                                                        style={{
                                                          marginBottom: "0px",
                                                          fontSize: "16px",
                                                          fontWeight: "700"
                                                        }}
                                                        class="clippable-spacer"
                                                      >
                                                        King of Clubs
                                                      </h4>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>
                                                      <div
                                                        id="bstatus3"
                                                        style={{
                                                          float: "left",
                                                          color:
                                                            ClubsPL > 0
                                                              ? "green"
                                                              : "red"
                                                        }}
                                                      >
                                                        {ClubsPL != 0
                                                          ? formatTruncate(
                                                              ClubsPL
                                                            )
                                                          : " "}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </span>
                                          </div>
                                        </h3>

                                        <div class="price-row-box-new">
                                          <div
                                            class={
                                              isSuspended
                                                ? "runner-disabled2 suspendCls"
                                                : "runner-disabled2 suspendCls hides"
                                            }
                                          >
                                            {suspendedText}
                                          </div>

                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a
                                            class="price-price price-back mb-show span1details"
                                            data-teamname="Clubs"
                                            data-bettype="b"
                                            id="runner3b1span"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "b",
                                                "Clubs",
                                                "Clubs",
                                                ClubsOdds,
                                                "m",
                                                3
                                              )
                                            }
                                          >
                                            <div id="rnr3" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner3b1"
                                              >
                                                {ClubsOdds}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate3"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a
                                            class="price-price price-lay ml-4 mb-show span1details"
                                            id="runner3l1span"
                                            data-teamname="Clubs"
                                            data-bettype="l"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "l",
                                                "Clubs",
                                                "Clubs",
                                                ClubsOddsLay,
                                                "m",
                                                3
                                              )
                                            }
                                          >
                                            <div id="rnr33" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner3l1"
                                              >
                                                {ClubsOddsLay}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate33"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a class="price-price price-lay whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-lay mr-4 whtBack">
                                            <div>&nbsp;</div>
                                          </a>
                                        </div>
                                      </div>

                                      <div
                                        class={
                                          diamondsWinner && cardsSettled
                                            ? "runner-runner sussesBg"
                                            : "runner-runner"
                                        }
                                      >
                                        <h3 class="runner-name" id="b4Sucess">
                                          <div class="runner-info">
                                            <span class="clippable runner-display-name">
                                              <table>
                                                <tbody>
                                                  <tr>
                                                    <td>
                                                      <h4
                                                        style={{
                                                          marginBottom: "0px",
                                                          fontSize: "16px",
                                                          fontWeight: "700"
                                                        }}
                                                        class="clippable-spacer"
                                                      >
                                                        King of Diamonds
                                                      </h4>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>
                                                      <div
                                                        style={{
                                                          float: "left",
                                                          color:
                                                            DiamondsPL > 0
                                                              ? "green"
                                                              : "red"
                                                        }}
                                                      >
                                                        {DiamondsPL != 0
                                                          ? formatTruncate(
                                                              DiamondsPL
                                                            )
                                                          : " "}
                                                      </div>
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </span>
                                          </div>
                                        </h3>

                                        <div class="price-row-box-new">
                                          <div
                                            class={
                                              isSuspended
                                                ? "runner-disabled2 suspendCls"
                                                : "runner-disabled2 suspendCls hides"
                                            }
                                          >
                                            {suspendedText}
                                          </div>

                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-back whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a
                                            class="price-price price-back mb-show span1details"
                                            id="runner3b1span"
                                            data-teamname="Diamonds"
                                            data-bettype="b"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "b",
                                                "Diamonds",
                                                "Diamonds",
                                                DiamondsOdds,
                                                "m",
                                                4
                                              )
                                            }
                                          >
                                            <div id="rnr4" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner4b1"
                                              >
                                                {DiamondsOdds}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate4"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a
                                            class="price-price price-lay ml-4 mb-show span1details"
                                            id="runner3l1span"
                                            data-teamname="Diamonds"
                                            data-bettype="l"
                                            onClick={() =>
                                              showBetfairBetSlip(
                                                "l",
                                                "Diamonds",
                                                "Diamonds",
                                                DiamondsOddsLay,
                                                "m",
                                                4
                                              )
                                            }
                                          >
                                            <div id="rnr44" class="sus_cls">
                                              <span
                                                class="price-odd odd"
                                                id="runner4l1"
                                              >
                                                {DiamondsOddsLay}
                                              </span>
                                              <span
                                                class="price-amount"
                                                id="rate44"
                                              >
                                                {stakeLimit}
                                              </span>
                                            </div>
                                          </a>

                                          <a class="price-price price-lay whtBack">
                                            <div>&nbsp;</div>
                                          </a>

                                          <a class="price-price price-lay mr-4 whtBack">
                                            <div>&nbsp;</div>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                                <span
                                  style={{
                                    display: activeTabIndex == 2 ? "" : "none"
                                  }}
                                >
                                  <Race20Result resultData={resultData} />
                                </span>
                              </span>
                              <span
                                style={{
                                  opacity: 1,
                                  display: activeTabIndex == 2 ? "" : "none"
                                }}
                              >
                                <Race20Result resultData={resultData} />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style>
            {`
                .race20-virtual-scope .race20-gradient {
                  position: relative;
                  background: #000000;
                  overflow: hidden;
                }

                .race20-virtual-scope .race20-gradient::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  background: radial-gradient(
                    ellipse 100% 44% at 50% calc(30% + 100px),
                    rgba(62, 193, 65, 0.95) 0%,
                    rgba(62, 193, 65, 0.8) 15%,
                    rgba(30, 80, 35, 0.5) 40%,
                    #1e1e1e 55%,
                    #1e1e1e 100%
                  );
                  opacity: 0.4;
                  pointer-events: none;
                  z-index: 0;
                }

                .race20-virtual-scope .race20-gradient > * {
                  position: relative;
                  z-index: 1;
                }

                .race20-virtual-scope .cards-layout.blackjack {
                  position: relative;
                  background: #000000 !important;
                }

                .race20-virtual-scope .cards-layout.blackjack::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  left: 0;
                  background: radial-gradient(
                    ellipse 100% 44% at 50% calc(30% + 100px),
                    rgba(62, 193, 65, 0.95) 0%,
                    rgba(62, 193, 65, 0.8) 15%,
                    rgba(30, 80, 35, 0.5) 40%,
                    #1e1e1e 55%,
                    #1e1e1e 100%
                  );
                  opacity: 0.4;
                  pointer-events: none;
                  z-index: 0;
                }

                .race20-virtual-scope .cards-layout.blackjack > * {
                  position: relative;
                  z-index: 1;
                }

                .race20-virtual-scope .blackjack {
                  background: #000000 !important;
                }

                .race20-virtual-scope .blackjack::before {
                  content: none !important;
                  display: none !important;
                }

                .race20-virtual-scope .player-scope .player-card {
                  background: transparent !important;
                }

                .race20-virtual-scope .race20-timer-row {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 0 12px;
                  position: relative;
                  z-index: 2;
                }

                .race20-virtual-scope .race20-timer-row .race20-left-col {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  position: relative;
                  top: -15px;
                  z-index: 2;
                }

                .race20-virtual-scope .race20-timer-row .Connectedclients {
                  position: relative;
                  top: 0;
                  margin: 0;
                  opacity: 0.9;
                  z-index: 2;
                  float: none;
                  width: auto;
                  display: inline-flex;
                  align-items: center;
                }

                .race20-virtual-scope .race20-timer-row .teenpatti-base-timer {
                  position: relative;
                  top: -5px;
                  right: -4px;
                  margin-left: auto;
                }

                .race20-virtual-scope .race20-left-col .sound-icon {
                  transform: scale(0.8);
                  transform-origin: center;
                  margin-top: 12px;
                }

                .player {
                  margin: 4px;
                  display: inline-block;
                  justify-content: space-between;
                  flex: 1 0 0;
                  flex-wrap: wrap;
                  margin-top: -5px;
              }

              .player-item {
                margin-bottom: 16px;
                display: block;
                margin-right: 0;
                z-index: 0;
                
            }
                .race20-virtual-scope.player-scope .player-item .name {
                    display: block;
                    color: #d7bc7b;
                    font-size: 12px;
                    font-weight: 700;
                    padding-bottom: 5px;
                    text-align: center;
                }
                .player-item .player-card {
                    border-radius: 12px;
                    border: 1px solid rgba(178, 220, 175, 0.25);
                }
                .BFBCardHandView {
                  transform: translate3d(0, 0, 0);
                  /* width: 220px; */
                  width: 100%;
                  height: 50px;
                  margin-top: 5px;
                  margin-bottom: 5px;
              }
                 
                .BFBCardFanView{
                    padding:0px;
                }
                .player-scope .player-card {
                  border: 1px solid rgba(178, 220, 175, 0.25);
                  justify-content: center;
                  width: 97%;
                  height: 50px;
                  border-radius: 15px;
                  padding: 2px;
                  background: transparent;
              }
              .card1 {
                transform: perspective(430px) translateZ(0) rotateZ(0deg) rotateY(0deg);
                width: 40px;
                height: 50px;
                transform-origin: 50% 100%;
                margin-left: 5px;
                float: left;
            }

            .row{
              padding-left: 3px;
            }
            .video-button{
              height: 30px !important;
              width: 40px !important;
            }

            @media (max-width:576px){
              .cards-layout.blackjack {
                min-height: 120px !important;
              }
              .player-scope .table-player .player {
                width: 170px !important;
                height: 70px !important;
              }
              .titlebarname p{
                font-size: 14px;
              }
              .cards-layout.blackjack .col-12{
                padding-left:0;
                padding-right:0;
              }
              .tp-card img{
                height: 55px;   
                width: auto;
                border-radius: 3px;
              }
              .row{
                padding-left: 0px;
              }
              .player-item {
                margin-top: 20px !important;
              }
              .space{
                margin-top: -20px;
              }
              .player-card{
                width: 92% !important;
                height: 60px !important;
              }
              .col-md-4
              {
                margin-top: 10px;
              }
            }
                `}
          </style>
        </div>
      </ClientLayoutWithOutHeader>
    </div>
  );
}
